// src/hooks/useFetchItems.ts
import { useState, useEffect } from 'react';
import config from '../config';
import { ApiDeviceResponse } from '../interfaces';
import { useSession } from '../contexts/SessionContext';

interface FilterCriteria {
  id?: string;
  name?: string;
  description?: string;
}

const useFetchDevices = (filterCriteria: FilterCriteria) => {
  const [apiResponse, setApiResponse] = useState<ApiDeviceResponse>({ result: [], total: 0});
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        // Filter out keys with empty values
        const nonEmptyFilterCriteria = Object.fromEntries(
          Object.entries(filterCriteria).filter(([_, value]) => value !== '')
        );
        
        // Create query parameters string
        const queryParams = new URLSearchParams(nonEmptyFilterCriteria).toString();
        const token = sessionState.account?.token;
        const response = await fetch(`${config.centralApiBaseUrl}/device?index=0&nbItems=10&descOrder=false&${queryParams}`, {
          method: 'GET',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch items');
        }

        const data = await response.json();
        setApiResponse(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An unknown error occurred');
      }
    };

    fetchDevices();
  }, [filterCriteria, sessionState]);

  return { apiResponse, error };
};

export default useFetchDevices;
